import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React from "react";
import Button from "../../atoms/button/button.component.js";
import Card from "../../atoms/card/card.component.js";
import Icon from "../../atoms/icon/icon.component.js";
import MergeUnit from "../merge-unit/merge-unit.component.js";
import {MergeQueueCardContainer, MergeQueueGridContainer} from "./merge-queue-card.styles.js";
function MergeQueueCard({
  mergeSuggestion,
  onMerge,
  onRemoveFromQueue
}) {
  const {
    t
  } = useTranslation();
  const [source, destination] = mergeSuggestion;
  return /* @__PURE__ */ React.createElement(MergeQueueGridContainer, {
    item: true,
    md: 3,
    sm: 4,
    xs: 6
  }, /* @__PURE__ */ React.createElement(Card, {
    raised: false
  }, /* @__PURE__ */ React.createElement(MergeQueueCardContainer, null, /* @__PURE__ */ React.createElement(Icon, {
    onClick: onRemoveFromQueue,
    color: "secondary"
  }, "cancel"), /* @__PURE__ */ React.createElement(MergeUnit, {
    source,
    destination
  }), /* @__PURE__ */ React.createElement(Button, {
    onClick: onMerge,
    variant: "outlined",
    color: "secondary"
  }, t("units.merge")))));
}
export default /* @__PURE__ */ React.memo(MergeQueueCard);
